export default __webpack_public_path__ + "67cbdab5307c270e2f05df97fa3eeaf3.png";